import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=768be6a6&scoped=true"
var script = {}
import style0 from "./PageNotFound.vue?vue&type=style&index=0&id=768be6a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../frontend-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768be6a6",
  null
  
)

export default component.exports